var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-map" }, [
    _vm.nextContent !== ""
      ? _c("div", { staticClass: "c-map__skip" }, [
          _c("a", { attrs: { href: "#" + _vm.nextContent } }, [
            _vm._v("Hoppa över karta")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-map__container",
      style: "min-height:" + _vm.height + "px",
      attrs: { id: _vm.mapName }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }